import { Component, ElementRef, Input, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { InsuranceHubBaseComponent } from "src/app/cover-folder/Insurance-hub-callback";
import { InsuranceHubService } from "src/app/services/Insurance-hub.service";
import { CommonModule } from "@angular/common";

export interface content {
  id?: string;
  title?: string;
  body?: string;
}
declare var bootstrap: any;

@Component({
  selector: "app-credit-life-mobile-premium-drawer",
  standalone: true,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [CommonModule],  
  templateUrl: "./creditLifeMobilePremiumDrawer.component.html",
  styleUrls: ["./creditLifeMobilePremiumDrawer.component.css"],
})
export class CreditLifeMobilePremiumDrawerComponent extends InsuranceHubBaseComponent {
  @Input() content: content = {};
  @ViewChild("mobilePremiumOffcanvas", { static: false }) mobilePremiumOffcanvas!: ElementRef;
  PolicyDetailResponse: any = {};
  relation: any;
  
  // Public method - can be called from outside components
  public openDrawer(policyDetails: any) {
    this.PolicyDetailResponse = policyDetails;
    this.openOffcanvas();
 }
  openOffcanvas() {
    const htmlDoc = document.getElementsByTagName("html")[0];
    htmlDoc.style.overflow = "hidden";
    const element = this.mobilePremiumOffcanvas?.nativeElement;

    if (!element) return;

    let instance = bootstrap.Offcanvas.getInstance(element);

    if (!instance) {
      instance = new bootstrap.Offcanvas(element, {
        backdrop: true,
        scroll: false,
        keyboard: true,
      });

      element.addEventListener("hidden.bs.offcanvas", () => {
        document.documentElement.style.overflow = "";
      });
    }

    instance.show();
  }
  closeOffcanvas() {
    const htmlDoc = document.getElementsByTagName("html")[0];
    htmlDoc.style.overflow = "";

    const element = this.mobilePremiumOffcanvas?.nativeElement;
    if (!element) return;

    let instance = bootstrap.Offcanvas.getInstance(element);

    if (!instance) {
      instance = new bootstrap.Offcanvas(element, {
        backdrop: true,
        scroll: false,
        keyboard: true,
      });
      element.addEventListener("hidden.bs.offcanvas", () => {
        document.documentElement.style.overflow = "";
      });
    }

    instance.hide();
  }
}
